/**
 * 現在のページのURLに基づいて、APIのホストURLを生成する関数。
 * - `localhost` や `10.48.5.3` の場合は、相対パスでAPIのURLを返します。
 * - 本番環境では、現在のURLから`-signage`や`-wall`を`-api`に置換し、APIのURLを返します。
 *
 * @returns {string} APIのURL
 */
export const Apihost = (type: "wall" | "ist") => {
  const api_version = "v2"
  const hostname = window.location.hostname
  let fullURL = window.location.href
  // クエリパラメータを削除
  const queryIndex = fullURL.indexOf("?")
  if (queryIndex !== -1) {
    fullURL = fullURL.substring(0, queryIndex)
  }

  if (hostname === "localhost" || /^10\.\d+\.\d+\.\d+$/.test(hostname)) {
    return `/api/${api_version}/${type}`;
  } else if (process.env.REACT_APP_OLD_API === "true") {
    return `${fullURL?.replace(
      /-signage|-wall|-ist/g,
      "-api",
    )}api/${api_version}/${type}`;
  } else {
    switch (type) {
      case "ist":
        return `https://${process.env.REACT_APP_IST_API_HOST}`
      case "wall":
        // sliceは最後の"/"を消すため
        return `${fullURL?.replace(/-signage|-wall|-ist/g, "-api")}`.slice(
          0,
          -1
        )
      default:
        throw new Error(`Unknown API type: ${type}`)
    }
  }
}
